<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import QRcode from './QRCode.vue'
import ActionButton from '../components/ui-components/ActionButton.vue'

import { onClickOutside } from '@vueuse/core'
import { getStrings } from './pickerLanguage'

const emit = defineEmits(['close'])

const props = defineProps({
  loginLink: {
    type: String,
  },
  language: {
    type: String,
    required: true,
  },
})

const closePopup = () => {
  emit('close')
}

const popupRef = ref(null)
const languageStrings = computed(() => {
  return getStrings(props.language)
})

onClickOutside(popupRef, closePopup)
</script>

<template>
  <div
    data-testid="account-linker"
    ref="popupRef"
    class="main-popup-container">
    <div class="content-wrapper">
      <div class="title-wrapper">
        <div class="rectangle"></div>
        <h2>{{ languageStrings.connect_to_prime_title }}</h2>
      </div>

      <div class="qr-code">
        <QRcode
          :value="props.loginLink"
          renderAs="svg" />
      </div>
      <p v-html="languageStrings.connect_to_prime_body"></p>
      <ActionButton
        @click="closePopup"
        :label="languageStrings.ok"
        variant="accent"
        class="ok-button" />
    </div>
  </div>
</template>

<style scoped>
.main-popup-container {
  position: fixed;
  background-color: var(--background-color);
  color: var(--text-color);
  width: 460px;
  height: 600px;
  border-radius: 25px;
  border: 2px solid var(--background-reverse);
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  justify-content: center;
  z-index: 5;
  display: flex;
}

.content-wrapper {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.title-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.rectangle {
  width: 1rem;
  margin-right: 0.5rem;
  height: 40%;
  background-color: var(--primary-color);
}

h2 {
  font-family: var(--title-font);
  font-weight: 600;
  font-size: 1.2rem;
}

p {
  text-align: center;
  margin-bottom: 0;
}

.qr-code {
  text-align: center;
}

.ok-button {
  margin-bottom: 2rem;
}
</style>
